<template>

  <t-report-generate
      v-model="form"
      sub-validation-tag="sub-place-report-extract-item-by-enterprise"
      default-excel
      enable-generate-pdf
      enable-generate-excel
      enable-generate-word
      java-report
      title="Extrato de Locais">

    <t-input-person customer
                    v-model="form.customerId"/>

    <t-input-search v-model="form.typeEnterpriseId"
             :options="typeEnterpriseOptions"
             label="Perfil" select />





  </t-report-generate>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"
import ScheduleStatusType from "@/model/types/modules/checklist/ScheduleStatusType";
import typeEnterpriseService from "@/services/modules/place/TypeEnterprise.service";

export default {

  mixins: [pageDefaultMixin, pageReportItemMixin],
  name: 'ReportExtractSchedule',
  data() {
    return {
      ScheduleStatusType,
      path: "checklist/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      form: {
        customerId: 0,
        typeEnterpriseId: 0,
      },
      typeEnterpriseOptions: [],
    }
  },
  props: {},
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      await typeEnterpriseService.selectList().then((list) => {
        this.typeEnterpriseOptions = list
      }).catch(error => this.responseError(error))

    },

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
